document.addEventListener('DOMContentLoaded', () => {
  const avatarInput = document.getElementById('profile-avatar-modify');
  const avatarImg = document.getElementById('profile-avatar');
  const saveButton = document.getElementById('save-changes');
  const form = document.getElementById('profile-form');
  const formMessage = document.getElementById('profile-message');

  avatarInput.addEventListener('change', function (event) {
    const file = event.target.files[0];
  
    if (file) {
      const reader = new FileReader();

      reader.onload = function (e) {
        const imageDataUrl = e.target.result;
        avatarImg.src = imageDataUrl;
      };
  
      reader.readAsDataURL(file);

      activateSaveButton();
    }
  });

  function activateSaveButton() {
    formMessage.innerText = '';
    saveButton.disabled = false;
  }

  form.addEventListener('submit', function (event) {
      event.preventDefault();

      // Create FormData object to handle file uploads
      const formData = new FormData(form);
      formData.append("action", "update_avatar");
      
      form.classList.add('loading');

      // Fetch API to send the form data to the server
      fetch(themeVars.ajaxurl, {
        method: 'POST',
        body: formData,
      })
      .then(response => response.text())
      .then(data => {
        form.classList.remove('loading');
        formMessage.innerText = data;
      })
      .catch(error => {
          console.error('Error:', error);
      });
  });
})